import React from 'react'
import styles from './GlobalVision.module.css'
const data = [
    {
        id: 1,
        category: "Press releases",
        image: "/Images/most_watch1.webp",
        title: "Businesswire Press Release on FDA Approval",
        desc: "The Densgene® lenses are a breakthrough in contact lens technology, integrating two pat..."
    },
    {
        id: 2,
        category: "Upcoming events",
        image: "/Images/most_watch2.webp",
        title: "Businesswire Press Release on FDA Approval",
        desc: "The Densgene® lenses are a breakthrough in contact lens technology, integrating two pat..."
    },
    {
        id: 3,
        category: "Event Recaps",
        image: "/Images/most_watch3.webp",
        title: "Businesswire Press Release on FDA Approval",
        desc: "The Densgene® lenses are a breakthrough in contact lens technology, integrating two pat..."
    }
];
const GlobalVision = () => {
    return (
        <>
            <section className={styles.wrapper}>
                <div className={styles.LeftSecton}>
                    <div className={styles.container}>
                        <h2 className={styles.mainTitle}>
                            Global Vision Care Market to Reach <span className={styles.deffrentFamily}>$</span>215B by 2028
                        </h2>

                        <p className={styles.subtitle}>
                            Comprehensive analysis of market dynamics, regional growth patterns,
                            and key drivers shaping the future of vision care worldwide.
                            Our research indicates accelerating demand in Asia-Pacific markets.
                        </p>

                        {/* Section 1 */}
                        <div className={styles.section}>
                            <h3 className={styles.sectionTitle}>
                                <span className={styles.arrow}>→</span>
                                What it takes to be a Most Admired Company
                            </h3>

                            <div className={styles.sectionContent}>
                                <div className={styles.text}>
                                    <p className={styles.textp}>
                                        To compile the overall ranking, Fortune collaborated with Korn Ferry, the global consulting firm that has conducted the research for the World’s Most Admired Companies list since 1997. Executives, directors and analysts in 51 industries were asked to rate the reputation of enterprises in their respective sectors based on a mix of nine qualities: from investment value and social responsibility to excellence in leadership and ability to attract talent.
                                    </p>

                                    <p className={styles.textp}>
                                        Survey respondents helped select the 50 All-Stars by choosing the 10 companies they admire most, from a list of companies that ranked in the top 25% on last year’s survey and in the top 20% of their industry
                                    </p>
                                </div>

                                <div className={styles.imageBox}>
                                    <img
                                        src="/Images/Medical_img.webp"
                                        alt="Medical"
                                    loading="lazy" decoding="async" />
                                </div>
                            </div>
                        </div>

                        {/* Section 2 */}
                        <div className={styles.section}>
                            <h3 className={styles.sectionTitle}>
                                <span className={styles.arrow}>→</span>
                                A focus on health and care
                            </h3>

                            <p className={styles.textp}>
                                Every day, Johnson & Johnson’s more than 130,000 employees are
                                building a world where complex diseases are prevented and cured.
                            </p>
                        </div>

                        {/* Section 3 */}
                        <div className={styles.section}>
                            <h3 className={styles.sectionTitle}>
                                <span className={styles.arrow}>→</span>
                                A focus on health and care
                            </h3>

                            <p className={styles.textp}>
                                BrunoMd vision care is honored to once again be among Fortune’s
                                World’s Most Admired Companies.
                            </p>
                        </div>
                        <div className={styles.bottomLine}></div>
                        <section className={styles.sectionlast}>
                            <div className={styles.header}>
                                <h2>Most watches</h2>
                                {/* <span className={styles.viewAll}>View all</span> */}
                            </div>

                            <div className={styles.grid}>
                                {data.map((item) => (
                                    <div key={item.id} className={styles.card1}>
                                        <div className={styles.imageWrapper}>
                                            <img src={item.image} alt={item.title} loading="lazy" decoding="async" />
                                        </div>

                                        <span className={styles.badge}>{item.category}</span>

                                        <h3 className={styles.title}>{item.title}</h3>

                                        <p className={styles.desc}>{item.desc}</p>
                                    </div>
                                ))}
                            </div>
                        </section>



                    </div>
                </div>
                <div className={styles.RightSecton}>
                    <div className={styles.sidebar}>

                        {/* Search */}
                        <div className={styles.searchBox}>
                            <input type="text" placeholder="Find help & support articles here" />
                        </div>

                        {/* Similar Articles */}
                        <div className={styles.card}>
                            <h3>View Similar Articles</h3>
                            <ul>
                                <li className={styles.active}>Using your own cells to fight cancer</li>
                                <li>Moving toward a more personalized appr...</li>
                                <li>5 ways BrunoMD vision care is innovati...</li>
                                <li>Our goal is a solution for every blad...</li>
                                <li>What are biologics?</li>
                                <li>Juvenile myasthenia gravis: Insid...</li>
                            </ul>
                        </div>

                        {/* Contact Form */}
                        <div className={styles.card}>
                            <h3>Contact Us</h3>

                            <label>Name</label>
                            <input type="text" placeholder="Your name" />

                            <label>Email*</label>
                            <input type="email" placeholder="Your Email Address" />

                            <button className={styles.submitBtn}>
                                <span>Submit</span>
                                <span className={styles.btnArrow}><img src='/svg/sumit_arrow.svg' alt='sumit_arrow' loading="lazy" decoding="async" /></span>
                            </button>
                        </div>

                        {/* Author */}
                        <div className={`${styles.card} ${styles.authorCard}`}>
                            <h3>About the Author</h3>

                            <div className={styles.authorInfo}>
                                <img
                                    src="https://i.pravatar.cc/60"
                                    alt="Author"
                                loading="lazy" decoding="async" />
                                <div>
                                    <p className={styles.authorName}>Marcus Johnson</p>
                                    <p className={styles.author}>Writer</p>
                                </div>
                            </div>

                            <p className={styles.authorDesc}>
                                Marcus Johnson is a seasoned writer specializing in biology trends,
                                with a deep passion for making complex topics accessible for readers.
                            </p>

                            <div className={styles.socials}>
                                <span><img src='/svg/linked_icon.svg' alt='linked_icon' loading="lazy" decoding="async" /></span>
                                <span><img src='/svg/Instagram_icon.svg' alt='Instagram_icon' loading="lazy" decoding="async" /></span>
                                <span><img src='/svg/twitter_icon.svg' alt='twitter_icon' loading="lazy" decoding="async" /></span>
                                <span><img src='/svg/Facebook_icon.svg' alt='Facebook_icon' loading="lazy" decoding="async" /></span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default GlobalVision
